import { useMutation } from '@hooks/reactQuery';

import { assetCheckInformation } from '@api/assets';

import { TAssetCheckInformationDTO } from '@interfaces/assets/dto/assetsDTO';

import { responseMessages } from '@constants/responseMessages';

interface ICheckUniqueAssetId extends TAssetCheckInformationDTO {
	successHandler: () => void;
	errorHandler: (value?: string) => void;
}

export const useMutateCheckUniqueAssetId = () => {
	const {
		mutate: checkUniqueAssetId,
		isLoading: isLoadingCheckUniqueAssetId,
	} = useMutation<ICheckUniqueAssetId>({
		mutationKey: [],
		mutationFn: ({
			assetId,
			id,
			successHandler,
			errorHandler,
		}: ICheckUniqueAssetId) => {
			const promiseCheck = assetCheckInformation({
				assetId: assetId || null,
				id,
			});

			promiseCheck
				.then(() => successHandler())
				.catch(err => {
					if (errorHandler) {
						errorHandler(err?.errors[0]?.message || responseMessages.error);
					}
				});
		},
	});

	return {
		checkUniqueAssetId,
		isLoadingCheckUniqueAssetId,
	};
};
